<mat-drawer-container class="container" autosize>
  @if (!isMobile()) {
    <mat-drawer #drawer class="sidenav" mode="over">
      <mat-nav-list class="nav-list">
        <h3 mat-subheader>Navigation</h3>
        <a mat-list-item routerLink="/authentication">Authenticate</a>
        <a mat-list-item routerLink="/chargepoints">Chargepoints</a>
        <a mat-list-item routerLink="/events">Events</a>
        <a mat-list-item routerLink="/traces">Traces</a>
        <a mat-list-item routerLink="/trace-cleanup">Nettoyage des traces</a>
        <a mat-list-item routerLink="/ocpp-expected-configuration">OCPP Configuration</a>
        <a mat-list-item routerLink="/session-stability">Stabilité OCPP</a>
      </mat-nav-list>
    </mat-drawer>
  }

  <mat-toolbar class="toolbar">
    @if (isMobile()) {
      <button
        mat-icon-button
        [matMenuTriggerFor]="mobileNavMenu"
        #mobileMenuTrigger="matMenuTrigger"
        aria-label="Navigation"
      >
        <mat-icon>{{ mobileMenuTrigger.menuOpen ? 'close' : 'menu' }}</mat-icon>
      </button>

      <mat-menu #mobileNavMenu="matMenu" panelClass="mobile-nav-menu-panel">
        <a mat-menu-item routerLink="/authentication" (click)="closeMobileMenu(mobileMenuTrigger)">Authenticate</a>
        <a mat-menu-item routerLink="/chargepoints" (click)="closeMobileMenu(mobileMenuTrigger)">Chargepoints</a>
        <a mat-menu-item routerLink="/events" (click)="closeMobileMenu(mobileMenuTrigger)">Events</a>
        <a mat-menu-item routerLink="/traces" (click)="closeMobileMenu(mobileMenuTrigger)">Traces</a>
        <a mat-menu-item routerLink="/trace-cleanup" (click)="closeMobileMenu(mobileMenuTrigger)">Nettoyage des traces</a>
        <a mat-menu-item routerLink="/ocpp-expected-configuration" (click)="closeMobileMenu(mobileMenuTrigger)">OCPP Configuration</a>
        <a mat-menu-item routerLink="/session-stability" (click)="closeMobileMenu(mobileMenuTrigger)">Stabilité OCPP</a>
      </mat-menu>
    } @else {
      <button mat-icon-button (click)="toggleDrawer()">
        <mat-icon>menu</mat-icon>
      </button>
    }

    @if (!isMobile()) {
      <mat-icon>handyman</mat-icon>
      <span>Recharge +</span>
      <span>|</span>
      <span>Connect</span>
      <span>|</span>
      <app-breadcrumb></app-breadcrumb>
    }
    @if (!isMobile()) {
      <span class="spacer"></span>
    }
    <app-refresh-widget></app-refresh-widget>
  </mat-toolbar>

  <div class="page-content">
    <router-outlet />
  </div>
</mat-drawer-container>
